import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface AbstractPermissionsData {
    abstractId: number;
    agreedToRepurposingContent: boolean | null;
    agreedToSpeakerGuidelines: boolean | null;
    agreedToUsagePermission: boolean | null;
}

export class AbstractPermissions implements FormValidationModel<AbstractPermissionsData> {
    public data: AbstractPermissionsData;
    public rules: yup.Schema<AbstractPermissionsData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            agreedToRepurposingContent: null,
            agreedToSpeakerGuidelines: null,
            agreedToUsagePermission: null,
        };
        this.rules = yup.object<AbstractPermissionsData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            agreedToRepurposingContent: yup.boolean().nullable(true).required().label("Repurposing of content"),
            agreedToSpeakerGuidelines: yup.boolean()
                .oneOf([true], "Author(s) must agree to the speaker guidelines")
                .nullable(true).required().label("Speaker attestation"),
            agreedToUsagePermission: yup.boolean().nullable(true).required().label("Usage permission"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractPermissions.ts